<template>
  <div class="MatchContentModal">
    <el-dialog
      title="搜索"
      :visible.sync="visible"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      :append-to-body="true"
      @open="handleOpen"
    >
      <el-select
        style="width: 90%"
        v-model="value"
        filterable
        remote
        reserve-keyword
        placeholder=""
        :remote-method="remoteMethod"
        :loading="loading"
        v-scroll="loadMore"
        @change="handleSelect"
      >
        <el-option
          v-for="(item, index) in options"
          :key="index"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-button type="primary" @click="handleSearch">搜索</el-button>
      <div class="content">
        <div
          class="itemContentBox"
          v-for="(item, index) in contentList"
          :key="index"
        >
          <div class="itemTitle">{{ item.title }}</div>
          <div class="textBox">
            <span class="itemContent">{{ item.content }}</span>
            <el-button
              round
              size="small"
              plain
              type="primary"
              @click="handleCopy(item.content)"
              >复制
            </el-button>
          </div>
        </div>
      </div>
      <div class="footer">
        <el-button style="width: 80px" type="primary" @click="handleConfirm"
          >确定
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";

export default {
  name: "MatchContentModal",
  props: {
    searchVal: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      options: [],
      value: "",
      loading: false,
      list: [],
      query: "",
      contentList: [],
    };
  },
  computed: {
    ...mapState("courseCenter", ["matchTitleList", "matchContentList"]),
    visible: {
      get() {
        return this.$store.state.courseCenter.matchContentModalVisible;
      },
      set(value) {
        this.$store.commit("courseCenter/setData", {
          key: "matchContentModalVisible",
          value,
        });
      },
    },
  },
  watch: {
    searchVal: {
      handler: function (newValue, oldVal) {
        if (newValue !== oldVal) {
          this.value = newValue;
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    ...mapActions("courseCenter", ["getMatchTitle", "getMatchContent"]),
    ...mapMutations("courseCenter", ["setData"]),
    async handleOpen() {
      await this.getMatchContent({
        title: this.value,
      });
      this.contentList = this.matchContentList.data;
    },
    handleConfirm() {
      this.setData({
        key: "matchContentModalVisible",
        value: false,
      });
    },
    handleCopy(copyText) {
      this.$copyText(copyText)
        .then((e) => {
          this.$message.success("复制成功");
          console.log(e);
        })
        .catch((e) => {
          this.$message.warning("复制成功");
          console.log(e);
        });
    },
    async handleSelect(val) {
      await this.getMatchContent({
        title: val,
      });
      this.contentList = this.matchContentList.data;
    },
    async remoteMethod(query) {
      this.query = query;
      this.value = query;
      if (query !== "") {
        this.loading = true;
        await this.getMatchTitle({
          title: query,
        });
        this.list = this.matchTitleList.data.map((item) => {
          return { value: item, label: item };
        });
        setTimeout(() => {
          this.loading = false;
          this.options = this.list;
        }, 200);
      } else {
        this.options = [];
      }
    },
    async handleSearch() {
      await this.getMatchContent({
        title: this.query,
      });
      this.contentList = this.matchContentList.data;
    },
    async loadMore() {
      const currentPage = this.matchTitleList.page;
      const currentSize = this.matchTitleList.size;
      const currentTotal = this.matchTitleList.total;
      if (currentPage * currentSize < currentTotal) {
        await this.getMatchTitle({
          title: this.query,
          page: this.matchTitleList.page + 1,
        });
        this.list = this.list.concat(
          this.matchTitleList.data.map((item) => {
            return { value: item, label: item };
          })
        );
        setTimeout(() => {
          this.loading = false;
          this.options = this.list;
        }, 200);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog {
  min-width: 880px;
  min-height: 650px;
  margin-top: 15vh !important;
  text-align: center;
}

::v-deep .el-dialog .el-dialog__body {
  padding: 20px 30px !important;
}

.content {
  //border: 1px solid #dcdfe6;
  border-radius: 6px;
  max-height: 450px;
  overflow-y: auto;
  margin-top: 20px;
  padding: 15px;

  .itemContentBox {
    text-align: left;
    border-radius: 6px;

    .itemTitle {
      font-size: 15px;
      font-weight: bold;
      color: #333333;
    }

    .textBox {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 15px 0;
    }

    .itemContent {
      padding: 15px;
      background-color: #f2f2f2;
      margin-right: 20px;
    }
  }
}

.footer {
  position: absolute;
  text-align: center;
  bottom: 10px;
  right: 50%;
  left: 50%;
}
</style>
